import { render, staticRenderFns } from "./uploadQuery.vue?vue&type=template&id=68dfda20&scoped=true"
import script from "./uploadQuery.vue?vue&type=script&lang=js"
export * from "./uploadQuery.vue?vue&type=script&lang=js"
import style0 from "./uploadQuery.vue?vue&type=style&index=0&id=68dfda20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfda20",
  null
  
)

export default component.exports